export default "__VITE_ASSET__CoJcKItJ__"